import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const state = {
  mainId: '',
  allAxiosSource: [], // 请求canceltoken列表,
  deleteTabsItem: {
    change: Date.parse(new Date()),
    item: ''
  }
};

const mutations = {
  getMainId(stateOne, val) {
    window.sessionStorage.mainId = val;
    stateOne.mainId = val;
  },
  cancleAxios(stateTwo) {
    const newAll = stateTwo.allAxiosSource;
    // 删除已经结束的请求
    newAll.foreach((item, index) => {
      if (item.source === null) {
        newAll.splice(index, 1);
      }
    });
    // 取消还未结束的请求
    newAll.foreach((item) => {
      if (item !== null && item.source !== null && item.status === 1) {
        item.state = 0;
        item.source.cancel('取消上一个');
      }
    });
    stateTwo.allAxiosSource = newAll;
  },
  getNewAxios(stateThree, obj) {
    // 创建新的请求cancelToken,并设置状态请求中
    console.log(obj.axios, 'Axios');
    const src = {
      source: obj.axios.CancelToken.source(),
      status: 1 // 1请求中 0取消中
    };
    if (obj.type === 'add') {
      stateThree.allAxiosSource.push(src);
      return src.source.token;
    }
    if (obj.type === 'cancel') {
      src.source = null;
    }
  },
  // 删除tabs
  deleteTabs(stateFour, obj) {
    stateFour.deleteTabsItem.change = Date.parse(new Date());
    stateFour.deleteTabsItem.item = obj;
  }
};
export default new Vuex.Store({
  state,
  mutations
});
